module.exports = require('./src/index')
